import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { AppProductDetailsComponent } from '../app-product-details/app-product-details.component';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { CartProductService } from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'meu-app-product-bottom-sheet',
  templateUrl: './app-product-bottom-sheet.component.html',
  styleUrls: ['./app-product-bottom-sheet.component.scss'],
})
export class AppProductBottomSheetComponent implements OnInit {
  lstTypeSelectedId$: any = new Subject();
  quantitySelected: number = 1;
  subTypeId: any;
  price = 0;
  quantity: number = 1;
  originPrice;
  save = 0;
  host = environment.backendhost;
  constructor(
    public bottomSheetRef: MatBottomSheetRef<AppProductDetailsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public productData,
    private cartProductService: CartProductService,
    private toastrService: ToastrService,
    private router: Router
  ) {}

  ngOnInit() {
    this.quantitySelected = this.productData.quantitySelected;
    this.lstTypeSelectedId$.subscribe((data) => {
      this.productData.data.extend_product_type.map((item) => {
        if (_.isEqual(item.type_id, data)) {
          this.subTypeId = item.id;
          this.price = item.price;
          this.originPrice = item.orgin_price;
          this.quantity = item.quantity;
          this.save = Math.round(100 - (this.price / this.originPrice) * 100);
          return;
        }
      });
    });
    if (this.productData.data.extend_type.length > 0) {
      this.productTypeSelected(0, 0);
    } else {
      this.subTypeId = '';
      this.price = this.productData.data.price;
      this.originPrice = this.productData.data.orgin_price;
      this.quantity = this.productData.data.quantity;
    }
  }
  productTypeSelected(lstTypeIndex, typeIndex) {
    this.productData.data.extend_type[lstTypeIndex].types.map((item, index) => {
      if (index == typeIndex) {
        this.productData.selected.splice(lstTypeIndex, 1, item.id);
        this.lstTypeSelectedId$.next(this.productData.selected);
        return (item.checked = true);
      } else {
        return (item.checked = false);
      }
    });
  }

  addCartProduct(isOrder) {
    if (this.quantitySelected <= 0) {
      this.toastrService.warning('Số lượng không hợp lệ');
      return;
    }

    this.cartProductService
      .apiMyCartProductsPost(this.productData.data.id, this.quantitySelected, this.subTypeId)
      .subscribe((res) => {
        this.bottomSheetRef.dismiss();
        if (res.success) {
          this.cartProductService.apiMyCartProductsGet().subscribe((reslst) => {
            if (reslst.success) {
              if (reslst.data.collection.length == 0) {
                $('.numberOfProduct').text('');
              } else {
                $('.numberOfProduct').text(reslst.data.collection.length);
              }
            }
          });
          if (isOrder) {
            this.router.navigate(['cart']);
          }
          // this.toastrService.success('Thêm vào giỏ hàng thành công', '')
        } else {
          this.toastrService.error('Thao tác không thành công', '');
        }
      });
  }

  changeQuantity(event) {
    if (!event) {
      this.quantitySelected = 0;
    } else {
      this.quantitySelected = event;
    }
  }
}
